import 'Assets/css/app.min.css'
import 'Assets/css/cn/app.min.css'
// import 'Assets/css/style.min.css'
import 'Assets/css/cn/bob.min.css'
require("Assets/js/footer.js");
require("Assets/js/cn/bob.min.js");